import { Dayjs } from 'dayjs'
import { useMemo } from 'react'
import { useUser } from '../../../../hooks/use-user'
import { useGetOvertimesQuery } from '../../../../store/api/overtimes-api'
import { EndpointQueryParameters } from '../../../../types/strapi/strapi'

function buildOvertimesQueryParams(userDocumentId: string, month: Dayjs): EndpointQueryParameters {
    return {
        filters: {
            date: {
                $gte: month.startOf('month').format('YYYY-MM-DD'),
                $lte: month.endOf('month').format('YYYY-MM-DD'),
            },
            user: {
                created_by_permissions_user: {
                    documentId: { $eq: userDocumentId },
                },
            },
        },
        fields: ['hours'],
        pagination: {
            page: 1,
            pageSize: 500,
        },
    }
}

export default function useDesignerOvertimeHours(month: Dayjs) {
    const user = useUser()

    const queryParams = useMemo(
        () => (user?.documentId ? buildOvertimesQueryParams(user.documentId, month) : undefined),
        [user?.documentId, month]
    )

    const { data, isLoading, isFetching } = useGetOvertimesQuery(queryParams, {
        skip: !queryParams,
    })

    const overtimeHours = useMemo(
        () => (data?.data ?? []).reduce((sum, item) => sum + (Number(item.hours) || 0), 0),
        [data?.data]
    )

    return {
        overtimeHours,
        isLoading: isLoading || isFetching,
    }
}
